import { useCanvasContext } from './useCanvas';
import useResponsiveSize from './useResponsiveSize';
import { default as WaveObj } from './lib/waveMobile';

const Wave = () => {
    const { context } = useCanvasContext();
    const { width, height } = useResponsiveSize();
    let frequency = 0.013;
    const waves = {
        frontWave: new WaveObj([0.021, 0.013, 0.015], 'rgba(0, 185, 225, 0.6)'),
        backWave: new WaveObj([0.012, 0.009, 0.016], 'rgba(0, 185, 225, 0.8)'),
    };

    const render = () => {
        context?.clearRect(0, 0, width, height);
        Object.entries(waves).forEach(([, wave]) => {
            wave.draw(context, width, height, frequency);
        });
        frequency += 0.013;
        requestAnimationFrame(render);
    };
    if (context) render();
    return null;
};

export default Wave;